import { Record } from 'immutable';

const generalStateRecord = Record({
  healyMembers: [],
  isBusy: 0
});

export class GeneralState extends generalStateRecord {
  healyMembers: HealyMember[];
  isBusy: number;
}

export interface HealyMember {
  id: number;
  name: string;
  lastname: string;
  email: string;
  rankId: number;
  country: string;
  selected: boolean;
}
